import { useContext, useEffect } from "react";
import UserContext from "../UserContext";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function Logout() {
  const { unsetUser, setUser } = useContext(UserContext);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out of your account.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, log me out",
    }).then((result) => {
      if (result.isConfirmed) {
        unsetUser();
        setUser({
          id: null,
        });
        Swal.fire("Logged Out", "You have been successfully logged out.", "success").then(() => {
          navigate("/"); // Redirect to Home after logout
        });
      } else {
        navigate(-1); // Go back to the previous page if the user cancels
      }
    });
  }, [unsetUser, setUser, navigate]);

  return null; // No need to render anything
}